function SlotDates($q, DayService) {
    'ngInject';

    const cached = {
        firstSlotDate: null,
        timesQueried: 0
    };

    const getFirstDayWithSlots = function (cItem, selected_day) {
        const deferred = $q.defer();

        if (cached.firstSlotDate != null) {
            deferred.resolve(cached.firstSlotDate);
            return deferred.promise;
        }

        const endDate = selected_day.clone().add(3, 'month');

        DayService.query({
            cItem,
            date: selected_day.format('YYYY-MM-DD'),
            edate: endDate.format('YYYY-MM-DD')
        }).then((days) => {
                cached.timesQueried++;

                const firstAvailableSlots = _.find(days, day => day.spaces > 0);
                if (firstAvailableSlots) {
                    cached.firstSlotDate = firstAvailableSlots.date;
                    return deferred.resolve(cached.firstSlotDate);
                } else {
                    if (cached.timesQueried <= 4) {
                        return getFirstDayWithSlots(cItem, endDate).then(day => deferred.resolve(cached.firstSlotDate)
                            , err => deferred.reject(err));
                    } else {
                        return deferred.reject(new Error('PUBLIC_BOOKING.WEEK_CALENDAR.NO_AVAILABILITY'));
                    }
                }
            }
            , err => deferred.reject(new Error('ERROR.COULDNT_GET_AVAILABLE_DATES')));

        return deferred.promise;
    };

    return {getFirstDayWithSlots};
}

/**
 * @ngdoc service
 * @name BB.service:SlotDates
 *
 * @description
 * checks for the first date with available spaces
 */
angular
    .module('BB')
    .service('SlotDates', SlotDates);



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_services/slot_dates.service.js